import { render } from "./Home.htm?vue&type=template&id=670ea805"
import script from "./Home.js?vue&type=script&lang=js"
export * from "./Home.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__